import React, { FC } from 'react';
import { CALCULATIONS } from '@shared/constants/calculations.constants';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import CalculationValueOverlay from './CalculationValueOverlay';
import Calculation from './Calculation';
import { useCalculations } from './calculations.hook';
import CalculationVariable from './CalculationVariable';
import { MainLayout } from '@ui/layout';

const Calculations: FC = () => {
  const { classes, cx } = useStyles();

  const {
    storeySumExpressionVariables,
    activeVariable,
    setActiveVariable,
    hiddenVariableSums,
    variableSumValue,
    getVariableSum,
  } = useCalculations();

  return (
    <MainLayout>
      <MainLayout.Content>
        <Box
          sx={{
            mb: 6,
            pt: 16,
          }}
        >
          {activeVariable && (
            <CalculationValueOverlay
              storeySumExpressionVariables={storeySumExpressionVariables}
              activeVariable={activeVariable}
              variableSumValue={variableSumValue}
            />
          )}
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Variable</TableCell>
                  <TableCell align="left">Formula</TableCell>
                  <TableCell align="right">Sum</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.entries(CALCULATIONS).map(([key, { formula }]) => (
                  <TableRow key={key} className={classes.row}>
                    <CalculationVariable
                      storeySumExpressionVariablesSum={
                        storeySumExpressionVariables.sum
                      }
                      variable={key}
                      activeVariable={activeVariable}
                      setActiveVariable={setActiveVariable}
                    />
                    <TableCell className={classes.cell} align="left">
                      <Calculation
                        formula={formula}
                        activeVariable={activeVariable}
                        setActiveVariable={setActiveVariable}
                      />
                    </TableCell>
                    <TableCell
                      className={cx(classes.cell, classes.cellSum)}
                      align="right"
                    >
                      {getVariableSum(
                        hiddenVariableSums,
                        storeySumExpressionVariables.sum,
                        key,
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box />
        </Box>
      </MainLayout.Content>
    </MainLayout>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  row: {
    border: 0,
    boxShadow: 'none',
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  cell: { border: 0 },
  cellActive: { textShadow: `0 0 1px ${theme.palette.text.primary}` },
  cellReal: { fontWeight: 700 },
  cellSum: { whiteSpace: 'nowrap' },
}));

export default Calculations;
